import { render, staticRenderFns } from "./BoardPlaceholder.vue?vue&type=template&id=725f44e2&scoped=true&"
import script from "./BoardPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BoardPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./BoardPlaceholder.vue?vue&type=style&index=0&id=725f44e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f44e2",
  null
  
)

export default component.exports